module.exports = __webpack_public_path__ + "img/boardbot.82a9d46f.png";